import { HttpInterceptorFn } from '@angular/common/http';
import * as Sentry from "@sentry/angular";
import { tap } from 'rxjs';

export const sentryInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    tap({
      error: (error) => {
        if (error.status >= 500) {
          Sentry.captureException(error, {
            extra: {
              url: req.url,
              method: req.method,
              requestBody: req.body,
              responseBody: error.error,
              status: error.status,
            },
          });
        }
      }
    })
  );
};
